export default __webpack_public_path__ + "static/media/schultemix_locked.7200cc9f.svg";